import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LoadingIndicator, Tile } from '../../components';
import theme from '../../app.theme';
import moment from 'moment';

import Group from '../courses/group'

class Tests extends Component {
  constructor(props) {
    super(props);

    this.testBaseUrl = this.props.match.url;
    this.state = {};
  }

  loadTest(test){
    if (!test.detailedResultsAvailable) {
      return;
    }

    this.props.loadTest(test)
    this.props.history.push(`${this.testBaseUrl}/${test.id}`);
  }

  renderSubtitle(test) {
    if (test.questionsPerRun == null && test.questionsTotal > test.answersTotal && test.isExam) {
      return `${moment.utc(test.endDate).local().format('DD.MM. HH:mm')} - Richtige Antworten: ${test.correctAnswers}/${(test.questionsTotal)} (${((test.correctAnswers / (test.questionsTotal || test.answersTotal)) * 100).toFixed(1)}%)`;
    }

    return `${moment.utc(test.endDate).local().format('DD.MM. HH:mm')} - Richtige Antworten: ${test.correctAnswers}/${(test.questionCount || test.answersTotal)} (${((test.correctAnswers / (test.questionCount || test.answersTotal)) * 100).toFixed(1)}%)`;
  }

  renderResultContent(){
    if(!this.props.results || !this.props.results.length){
      return <h3 className="text-center">Noch keine Tests durchgeführt.</h3>
    }
    return (<div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 tileGroup">
            {this.props.results.map((test) => {
              return <Tile
                key={test.id}
                isResultTile
                title={test.testName}
                subtitle={this.renderSubtitle(test)}
                onClick={this.loadTest.bind(this, test)}
                imageUrl={test.imageUrl}
                progress={test.score || test.progress} />
              })}
        </div>
      )
  }

  render(){
    if (this.props.isLoading) {
      return <LoadingIndicator show centered />;
    }

    return (
      <div className="col-lg-12 col-md-12 col-sm-12">
        <div style={{paddingLeft: '15px'}}>
          <h1>Ergebnisse</h1>
        </div>
        {this.renderResultContent()}
      </div>
    )
  }
}

export default Tests;


// WEBPACK FOOTER //
// ./src/app/main/results/results.js